(function (global) {

  /**
  * Функции списка объектов
  * @namespace Core.objectList
  * @since 5.1.0.1523
  */
  global.objectList = {};


})(window.Core);


(function (global) {

  /**
  * Подписать указанные ссылки. 
  * @function Core.objectList.signListItems
  * @since 5.3.0.1001
  * @return {Core.objectList}
  */
  global.signListItems = function (items) {
    let links = []; 
    for (const item of items) {
      let linkModel = item.toLinkModel();
    // Добавляем наименование объекта что бы потом мы смогли выдать ошибку с наименование объекта.
      linkModel['name'] = item.name;
      links.push(linkModel);
    };
    return global.signLinks(links);
  }

  /**
  * Подписать указанные ссылки. 
  * @function Core.objectList.signLinks
  * @since 5.3.0.1001
  * @return {Core.objectList}
  */
  global.signLinks = function (links) {
    let sortedLinks = {
      documents: [],
      tasks: [],
      jobs: []
    };

    if (links) {
      for (const linkElement of links) {
        switch (linkElement.Kind.toLowerCase()) {
          case 'edoc':
            sortedLinks.documents.push(linkElement);
            break;
          case 'task':
            sortedLinks.tasks.push(linkElement);
            break;
          case 'job':
            sortedLinks.jobs.push(linkElement);
            break;
        }
      };
    }

    signSortedLinks(sortedLinks);
  };


  /**
  * Подписать указанные ссылки. 
  * @param {sorteLinks} объект со списком ссылок { 'documents': [{},{}], 'tasks': [{},{}...], 'jobs': [{}]}
  */
  const signSortedLinks = function (sortedLinks) {
    Core.agent.getPlugin('CryptographyPlugin').done(plugin => {
      if (sortedLinks.documents.length) {
        signDocuments(false);
      } else if (sortedLinks.tasks.length || sortedLinks.jobs.length) {
        signCustomWork();
      } else {
        (new WA.CMP.NTF.Toast).showMessage(L('NO_OBJECT_SELECTED'));
      }
    }).fail(needShowError => {
      if (needShowError) {
        showSigningUnsupportedDialog();
      }
    });
    
    /**
    * Подписание множества документов
    * @innner
    * @function signDocuments
    * @since 5.1.0.1505
    */
    function signDocuments(isSignCustomWork) {
      ShowModalWindow('MULTIPLE_SIGN', {
        title: L('EDOCUMENT_SIGN'),
        afterOpen: function () {
          const jModalWindow = $('#modal_window');
          BindHelpIcoClickOnModalWindow('Sign');
          jModalWindow.find('input[type=radio]:first').click();
          key.setScope('baseDialog');
          if ((sortedLinks.documents.length) && (sortedLinks.tasks.length || sortedLinks.jobs.length)) {
            //Выводим ошибку только если разные объекты
            jModalWindow.data('warning')(L('MULTIPLE_OBJECTS_SIGN_DIALOG_INPLACE_HINT'));
          }
          const jTokenPinMessage = jModalWindow.find('#new_error_container');
          const jTokenPinInput = jModalWindow.find('.token_pin_code');

          if (jTokenPinMessage.length != 0) {
            const tokenPinMessageHeight = jTokenPinMessage.parent().height();
            const tokenPinInputHeight = jTokenPinInput.parent().parent().height();
            const newHeight = jModalWindow.height() - tokenPinMessageHeight - tokenPinInputHeight;
            jTokenPinMessage.parent().hide();
            jTokenPinInput.parent().parent().hide();
            jModalWindow.height(newHeight);
          }
        },
        ok: function () {
          const handler = $('#modal_window').data('ok');
          if (handler) return handler();
        },
        cancel: function () {
          const handler = $('#modal_window').data('cancel');
          if (handler) return handler();
        },
        params: {
          Links: _.map(sortedLinks.documents, linkModel => {
            return Object.assign({'name': null}, linkModel)
          }),
          LinksTasks: _.map(sortedLinks.tasks, linkModel => {
            return Object.assign({}, linkModel)
          }),
          LinksJobs: _.map(sortedLinks.jobs, linkModel => {
            return Object.assign({}, linkModel); 
          }),
          UseAgent: true,
          IsSignCustomwork: isSignCustomWork,
        },
        height: 'auto',
        drag:  () => {
          $('#modal_window').parent().css('height', 'auto');
        },
        onClose:  () => {
          clearAllModalDivs();
          key.setScope('common');
        },
        position: ['center', (windowHeight() / 2) - 200]
      });
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Возврашает подписанное множество ЗЗУ
     * @innner
     * @function getSignedCustomWor
     * @since 5.4.0.1006
     */
    function getSignedCustomWork() {
      let results = [];
      for (const taskLink of sortedLinks.tasks) {
        results.push(SignTask(taskLink.ID, taskLink.name, true));
      }
      for (const jobLink of sortedLinks.jobs) {
        results.push(SignJob(jobLink.ID, jobLink.name, true));
      }

      return results;
    }

    /**
     * Подписание множества ЗЗУ
     * @innner
     * @function signCustomWork
     * @since 5.1.0.1505
     */
    function signCustomWork() {
      WA.SRV.request('/Certificates.asmx/GetSuitableCertificate',{},{
        hideSpinner: true,
        hideError:true}).done(res => {
          //Подходящий сертификат есть
          const results = getSignedCustomWork();

          $.whenAllDone.apply($, results).done((...args) => {
            if (args.length) {
              (new WA.CMP.NTF.Toast).show(L('MULTIPLE_SIGN_COMFIRMATION'));
            }
          }).fail((...args) => {
            if (args.length) {              
              const dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
              const details = new WA.CMP.forms.FormBuilder('signingDetails');
              details.setOrientation(ORIENTATION.VERTICAL);
              details.addTextFrame('NOT_ALL_OBJECTS_SIGNED_INFORMATION_MESSAGE', '<ul>' + args.join('') + '</ul>');

              details.renderAsync().done(data => {
                dialog.showError(L('MULTIPLE_SIGN_SUCCESS_WITH_ERROR'), data);
              });
            }
          });
        }).fail(()=> {
          //Подходящего сертификата нет, показывать окно
          signDocuments(true);
        })
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показывает диалог подписания с ошибкой "Пописание возможно только с агентом"
    * @innner
    * @function showSigningUnsupportedDialog
    */
    function showSigningUnsupportedDialog() {
      const err = L('ERR_SIGNING_UNSUPPORTED');
      const dialog = new WA.CMP.dialogs.MessageBox({
        isShowOkButton: true,
        isShowCancelButton: true,
        width: 600,
      });
      dialog.bind(WA.CMP.dialogs.BaseDialog.EVENT.AFTER_OPEN, () => {
        dialog.disableButton('modal_ok_button');
      });
      dialog.show('', '', L('EDOCUMENT_SIGN'));
      ShowMessageInDialog(dialog._jDialog, err, 'error');
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    return global;
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.objectList);
